import { Box, Stack, Typography } from "@mui/joy";
import React, { useEffect, useRef } from "react";
import login_main from "static/image/login/login_brain.png";
import { theme } from "styles/theme";
import CustomTypography from "components/common/CustomTypography";
import Link from "../../components/common/Link";
import { ShieldSmallIconSvg } from "../../static/image/common/SvgAssets";
import useGetDeviceInfo from "../../hooks/useGetDeviceInfo";
import useGetUrls from "../../hooks/useGetUrls";
import GoogleLoginButtonPromotion from "../../components/user/GoogleLoginButtonPromotion";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { userPromotionAtom } from "../../recoil/userPromotionAtom";
import AppleLoginButtonPromotion from "../../components/user/AppleLoginButtonPromotion";
import useAutoLoginPromotion from "../../hooks/useAutoLoginPromotion";

export default function PromotionLogin() {
  const { homeIndicatorHeight, appVersion } = useGetDeviceInfo();
  const { companyInfoUrl, privacyPolicyUrl, servicePolicyUrl } = useGetUrls();
  const navigate = useNavigate();
  useAutoLoginPromotion();
  const user = useRecoilValue(userPromotionAtom);

  const backgroundColor = theme.vars.palette.Background.Level2;
  const hasTrackedLoginComeRef = useRef(false);

  useEffect(() => {
    if (!hasTrackedLoginComeRef.current) {
      hasTrackedLoginComeRef.current = true;
    }
  }, []);

  // 이미 로그인되어 있으면 다음 페이지로 이동
  useEffect(() => {
    if (user?.userId) {
      if (user.nickname) {
        navigate("/promotion-payment", { replace: true });
      } else {
        navigate("/promotion-nickname-submit", { replace: true });
      }
    }
  }, [user, navigate]);

  const children = (
    <Stack
      direction="column"
      alignItems="center"
      justifyContent="center"
      spacing={4}
      sx={{
        flex: 1,
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "320px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 4,
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={login_main}
            alt="empty"
            style={{
              width: "100%",
              maxWidth: "266px",
              maxHeight: "clamp(120px, 32vh, 40vh)",
              objectFit: "contain",
            }}
          />
        </Box>

        <Stack spacing={"12px"} sx={{ textAlign: "center", width: "100%" }}>
          <CustomTypography
            variant="H1"
            sx={{
              color: theme.vars.palette.Content.Strong,
              fontWeight: 800,
            }}
          >
            {"계정을 만들고\n" + "프로그램을 시작하세요"}
          </CustomTypography>
        </Stack>

        {/* 로그인 버튼 영역 */}
        <Stack
          spacing={1}
          sx={{
            width: "100%",
          }}
          alignSelf="center"
        >
          {
            <>
              <AppleLoginButtonPromotion />
              <GoogleLoginButtonPromotion />
              <Stack
                direction={"row"}
                height={"32px"}
                alignItems={"center"}
                justifyContent={"center"}
                width={"100%"}
                sx={{ textAlign: "center", gap: "2px" }}
              >
                <ShieldSmallIconSvg
                  color={theme.vars.palette.Content.Highlight}
                />
                <Typography
                  variant={"Caption"}
                  sx={{
                    textAlign: "center",
                    color: theme.vars.palette.Content.Highlight,
                    fontWeight: 500,
                  }}
                >
                  {"100일 완성 295,000원부터 | 불만족시 전액 환불"}
                </Typography>
              </Stack>
            </>
          }
        </Stack>
      </Box>
    </Stack>
  );

  return (
    <Stack
      direction={"column"}
      alignItems="center"
      sx={{
        zIndex: 1000,
        position: "fixed",
        top: 0,
        width: "100vw",
        height: "calc(var(--vh,1vh) * 100)",
        minHeight: "calc(var(--vh,1vh) * 100)",
        backgroundColor: backgroundColor,
        pb: `${homeIndicatorHeight}px`,
      }}
    >
      {children}

      <Stack
        direction={"row"}
        spacing={"20px"}
        justifyContent="center"
        sx={{
          mt: "auto",
          mb: "0px",
          pt: 1,
          wordBreak: "keep-all",
          flexShrink: 0,
        }}
      >
        <Link
          opacity={100}
          bold={false}
          text={"사업자 정보"}
          url={companyInfoUrl}
        />
        <Link
          opacity={100}
          bold={false}
          text={"개인정보 처리방침"}
          url={privacyPolicyUrl}
        />
        <Link
          opacity={100}
          bold={false}
          text={"서비스 이용약관"}
          url={servicePolicyUrl}
        />
      </Stack>
    </Stack>
  );
}
